import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ModalDialogData } from '../../../core/models/model';
import { ToastService } from '../../../core/services/toast.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-dialog',
  imports: [
     MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule
  ],
  templateUrl: './modal-dialog.component.html',
  styleUrl: './modal-dialog.component.scss'
})
export class ModalDialogComponent {
  readonly modalData: ModalDialogData = inject<ModalDialogData>(MAT_DIALOG_DATA);
  toastService = inject(ToastService);
  router = inject(Router);

  dismiss() {
    this.toastService.dialogRef.close();
  }
}

